var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fLink"},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.panel.title))]),_c('dd',_vm._l((_vm.panel.children),function(link,index){return _c('link-item',{key:index,attrs:{"item":link}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }